import { render, staticRenderFns } from "./edit-data.vue?vue&type=template&id=42ca17bc&scoped=true&"
import script from "./edit-data.vue?vue&type=script&lang=js&"
export * from "./edit-data.vue?vue&type=script&lang=js&"
import style0 from "./edit-data.vue?vue&type=style&index=0&id=42ca17bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ca17bc",
  null
  
)

export default component.exports